import React, { useState, useEffect } from "react";
import { Table, Spin, message, Modal, Tag, Descriptions } from "antd";
import { VscEye } from "react-icons/vsc";
import axios from "axios";
import useSelectedServerVersionStore from "../../../../../components/hooks/useSelectedServerVersionStore";
import FinalEdaCel from "../../../client-manager/row-staus/FinalEdaCel";
import useInfraFormData from "../../../../../components/hooks/useInfraFormData";
import { useParams } from "react-router-dom";
import { useProjectInfoStore } from "../../../../../zustand/store/projectInfoStore";
import ServerVersionApproveRej from "./ServerVersionApproveRej";
import AccessTo from "../../../../../components/is-show/AccessTo";
import { PA } from "../../../../router/AddRoutesJson";
import { selectedServerVersionEdaTableDataStore } from "./../../../../../zustand/store/selectedServerVersionEdaTableDataStore";
import { RxReload } from "react-icons/rx";

function ServerProgress() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null); // Store content for the modal
  const [modalType, setModalType] = useState(""); // Track the type of modal (JSON or image)
  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const { id } = useParams();
  const {
    data: infraFormData,
    error: infraFormError,
    isLoading: infraFormLoading,
  } = useInfraFormData(id);
  const { setProjectInfoZustandState, projectInfoZustandState } =
    useProjectInfoStore();
  const {
    selectedServerVersionEdaTableDataZustandState,
    setSelectedServerVersionEdaTableData,
  } = selectedServerVersionEdaTableDataStore();

  const fetchServerProgress = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://lexhue53xg.execute-api.ap-southeast-1.amazonaws.com/prod/server-progres?event_type=get_select_server_version&projectKey=${projectInfoZustandState?.project_key}&version=${selectedServerVersionZustandState}`
      );
      // if (response?.data?.statusCode == 200) {
      setData(response?.data || []);
      // }
      setSelectedServerVersionEdaTableData(response?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("Failed to load data from the API!");
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    fetchServerProgress();
  }, [selectedServerVersionZustandState]);

  // Show modal with specific content
  const handleEyeClick = (type, content) => {
    setModalType(type); // Set the type of modal (JSON or image)
    setModalContent(content); // Set the content to display in the modal
    setIsModalVisible(true); // Open the modal
  };

  // Close modal
  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalContent(null);
    setModalType("");
  };

  const columns = [
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
    },
    {
      title: "Client Version",
      dataIndex: "client_version",
      key: "client_version",
    },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Client EDA",
      dataIndex: "client_eda",
      key: "client_eda",
      render: (eda) => (
        <div className="flex justify-center">
          <VscEye
            title="Click to view Client EDA"
            color="#0057b8"
            size={16}
            style={{ cursor: "pointer" }}
            onClick={() => handleEyeClick("image", eda)} // Pass type and content to modal
          />
        </div>
      ),
    },
    {
      title: "Final Model QC",
      dataIndex: "final_model_qc",
      key: "final_model_qc",
      render: (qc) => (
        <div className="flex justify-center">
          <VscEye
            title="Click to view Final Model QC"
            color="#0057b8"
            size={16}
            style={{ cursor: "pointer" }}
            onClick={() => handleEyeClick("json", qc)} // Pass type and content to modal
          />
        </div>
      ),
    },

    {
      title: "Final EDA",
      dataIndex: "final_eda",
      render: (finalEdaData, record, index) => {
        if (index === 0) {
          return {
            children: (
              <FinalEdaCel rowItems={record} infraFormData={infraFormData} />
            ),
            props: { rowSpan: data.length },
          };
        }
        return {
          props: { rowSpan: 0 },
        };
      },
      key: "qc3dsa",
    },
    {
      title: "Approval Status",
      dataIndex: "projectStatus",
      key: "projectStatus",
      className: "text-center",
      render: (sts, _, index) => {
        if (index === 0) {
          return {
            children: sts ? (
              <Tag
                className=" capitalize"
                color={sts == "approved" ? "green" : "red"}
              >
                {" "}
                {sts}
              </Tag>
            ) : (
              "-"
            ),
            props: { rowSpan: data.length },
          };
        }
        return {
          props: { rowSpan: 0 },
        };
      },
    },
    // {
    //   title: "Final EDA",
    //   dataIndex: "final_eda",
    //   key: "final_eda",
    //   render: (edaStatus, _, index) => {
    //     // Merge all rows into one
    //     return {
    //       children: (
    //         <div className="flex justify-center">
    //           {edaStatus.status == "SUCCESS" ? (
    //             <VscEye
    //               title="Click to view Final EDA"
    //               color="#0057b8"
    //               size={16}
    //               style={{ cursor: "pointer" }}
    //               onClick={() => handleEyeClick("eda", edaStatus)}
    //             />
    //           ) : (
    //             <Tag color="orange">Pending</Tag>
    //           )}
    //         </div>
    //       ),
    //       props: {
    //         rowSpan: index === 0 ? data.length : 0, // Row span for the first row
    //       },
    //     };
    //   },
    // },
  ];

  return (
    <div>
      <div className="flex justify-end">
        <button
          className="flex items-center justify-center px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600  transition ease-in-out duration-150"
          onClick={fetchServerProgress}
        >
          <RxReload />{" "}
        </button>{" "}
      </div>
      <div className="my-2"></div>
      <div className="border rounded-md">
        <Table
          columns={columns}
          loading={loading}
          dataSource={data}
          pagination={false}
          rowKey="id" // Ensure rows have a unique key
        />
        {/* Modal for displaying content */}
        <Modal
          title={modalType === "image" ? "Client EDA" : "Final Model QC"}
          open={isModalVisible}
          onCancel={handleModalClose}
          footer={null}
        >
          {/* {JSON.stringify(modalContent)} */}
          {modalType === "image" && modalContent ? (
            <img
              src={`data:image/png;base64,${modalContent?.resource}`}
              alt="Client EDA"
              style={{ width: "100%" }}
            />
          ) : modalType === "json" && modalContent ? (
            <>
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Loss">
                  {JSON.parse(modalContent?.resource)?.Loss}
                </Descriptions.Item>
                <Descriptions.Item label="Accuracy">
                  {JSON.parse(modalContent?.resource)?.Accuracy}
                </Descriptions.Item>
              </Descriptions>
            </>
          ) : (
            <p>No content available.</p>
          )}
        </Modal>
      </div>

      <AccessTo role={[PA]}>
        <ServerVersionApproveRej data={data} />
      </AccessTo>
    </div>
  );
}

export default ServerProgress;
